import React from "react";

export default function Title({ title }) {
	return <h2>{title}</h2>;
}
